module.exports = __webpack_public_path__ + "img/icn_transportation1.4184a99b.png";